import {FC} from 'react'
import classNames from 'classnames'
import styles from './Tab.scss'

interface Props {
  label: string
  active?: boolean
  onClick: () => void
}

export const Tab: FC<Props> = ({label, active, onClick}) => {
  return (
    <div className={classNames(styles.tab, active && styles.active)} onClick={onClick}>
      <div className={styles.inner}>
        <span>{label}</span>
      </div>
    </div>
  )
}
